import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL, getToken } from '../asyncConfig';

export const getTransactions = createAsyncThunk(
  'transaction/getAllTransactions', async (criterial, {rejectWithValue, fulfillWithValue}) => {
    try {
      const { data } = await axios.get(
        `${BASE_URL}/admin/retrieve/transactions/${criterial}`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );      
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const getTransactionById = createAsyncThunk(
  'transaction/getTransactionById', async ({id, criteria}, {rejectWithValue, fulfillWithValue}) => {
    try {
      const { data } = await axios.get(
        `${BASE_URL}/admin/transactions/${id}?criteria=${criteria}`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );      
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const getTransactionsFulfilled = (state, action) => {
  console.log('action', action);
  state.status = '';
  state.transactions = action.payload.transactions;
  state.transfer = action.payload.transfer || {};
  state.message = '';
}